import { FormattedMessage } from 'react-intl';
import type { DownloadableItemProps } from '@/features/DownloadableItem/types.ts';

export const footerDocuments: DownloadableItemProps[] = [
  {
    link: '/static/documents/politika-konfidecialnosti.pdf',
    title: <FormattedMessage defaultMessage="Политика конфидециальности" />,
  },
  {
    link: '/static/documents/soglasie-na-sbor-i-obrabotku-personalnyh-dannyh.pdf',
    title: (
      <FormattedMessage defaultMessage="Согласие на сбор и обработку персоналных данных" />
    ),
  },
  {
    link: '/static/documents/sertifikat.pdf',
    title: <FormattedMessage defaultMessage="Сертификат" />,
  },
];
